import { DataBean } from "../DataBean";

export class CashDeskAccountCDP extends DataBean {

    public async getCashDeskAccountCDPCatalog(year: any,idCashDeskAccount:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashDeskAccountCDPCatalog_Number_Number", [year,idCashDeskAccount]);
    }

    public async addCDPDocumentToCashDeskAccount(idCashDeskAccount:any,documentLocation:any,documentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.CashDeskAccountCDP_addCDPDocumentToCashDeskAccount_Number_Number_java.util.Date", [idCashDeskAccount,documentLocation,documentDate]);
    }
    public async getAccountantDocumentByLocation(documentLocation: any,date:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_getAccountantDocumentByLocation_Number_java.util.Date", [documentLocation,date]);
    }
}
